(function($) {
  $(function () {
    var cta = $('.page-content .extras');
    // Appending Download CTA to sidebar of the page
    var sidebar = $(
      ".page-node-type-document .region--sidebar .sidebar-extended"
    );
    if (sidebar.length) {
      var btnContainer = sidebar.find(".btn-container");
      if (!btnContainer.length) {
        btnContainer = $('<div class="btn-container"></div>');
        btnContainer.appendTo(sidebar);
      }
      cta.insertAfter(".block-better-social-sharing-buttons");
    }
  });
})(jQuery)
